import { registerPlugin } from '@capacitor/core';

const NativeSettings = registerPlugin('NativeSettings', {
  web: () => import('./NativeSettingsWeb').then(m => new m.NativeSettingsWeb()),
});

export default NativeSettings;
